export const cardStyle = {
  boxShadow:
    "inset 0px 0px 68px rgba(255, 255, 255, 0.05), inset 0px 4px 4px rgba(255, 255, 255, 0.15)",
  backdropFilter: "blur(86px)",
  background: "background: url(.png), rgba(255, 255, 255, 0.05)",
  WebkitBackdropFilter: "blur(86px)",
};
